export const KNOWLEDGE_LIST_ATTEMPT = "KNOWLEDGE_LIST_ATTEMPT";
export const KNOWLEDGE_LIST_SUCCESS = "KNOWLEDGE_LIST_SUCCESS";
export const KNOWLEDGE_LIST_FAILED = "KNOWLEDGE_LIST_FAILED";
////////////
export const KNOWLEDGE_MORELIST_ATTEMPT = "KNOWLEDGE_MORELIST_ATTEMPT";
export const KNOWLEDGE_MORELIST_SUCCESS = "KNOWLEDGE_MORELIST_SUCCESS";
export const KNOWLEDGE_MORELIST_FAILED = "KNOWLEDGE_MORELIST_FAILED";
